module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/new/assessment_achievements/2_88b6d5f3f2851365cce18a2677b404d3.png";